import React from "react";
import PropTypes from "prop-types";

const SmallOutlinedButton = ({
  name = "",
  type = "button",
  border = "2",
  id = "",
  onClick,
  disabled = false,
  ...props
}) => {
  return (
    <div>
      <button
        type={type}
        className="button-smal-outlined"
        id={id}
        disabled={disabled}
        onClick={onClick}
      >
        {name}
      </button>
    </div>
  );
};

SmallOutlinedButton.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default SmallOutlinedButton;
